<script setup lang="ts">
import { Disclosure } from "@headlessui/vue";

import LeFaqButton from "./LeFaqButton.vue";
import LeFaqPanel from "./LeFaqPanel.vue";

const emit = defineEmits<{
  click: [isOpen: boolean];
}>();

const onClick = (wasOpen: boolean) => {
  // We flip `wasOpen`, as the `open` prop has not updated when `click` fires
  emit("click", !wasOpen);
};
</script>

<template>
  <Disclosure v-slot="{ open }" as="div" class="le-faq-item">
    <LeFaqButton :open="open" @click="onClick(open)">
      <slot name="button" />
    </LeFaqButton>
    <LeFaqPanel><slot /></LeFaqPanel>
  </Disclosure>
</template>

<style scoped lang="less">
@import "@dsk/styles/all";

.le-faq-item {
  box-shadow: @shadows[dropdown];
}
</style>
